module.exports = __webpack_public_path__ + "img/framenew_box15.0d6a8a06.jpg";